import axios from 'axios';
// import qs from "qs";
// axios.create({
// 	// baseURL: location.origin + '/okr', // 公共接口-生产
// 	baseURL: 'http://gzjzyxh.tooge.cn/api/home', // 公共接口-本地
// 	timeout: 30 * 1000, // 超时时间单位是ms
// 	headers: {
// 		"Content-Type": "application/json;charset=UTF-8",
// 	},

// })
axios.interceptors.request.use(
	config => {
        // if(config.url=='/apply'){
        //     config.url = '/asdasdfsdf'

        //     console.log(config.data)
        // }else{
            (config.method === 'post'  || config.method === 'put' )?
            config.data = {
                ...config.data
            } :
			config.params = {
				...config.data
			};
        // }

		let development = process.env.NODE_ENV == 'development' ? true : false;
		if(development){
			config.baseURL = "https://test-dev.welamp.cn/api/home";
		}else{
			config.baseURL = '/api/home'
		}
		const rawToken = localStorage.getItem("MANAGETOKEN");
		if (rawToken) {
			config.headers.Authorization = 'Bearer ' + rawToken;
		}

		config.headers['Content-Type'] = "application/json;charset=UTF-8";
		config.timeout = 30 * 1000; // 超时时间单位是ms
        return config
	},
	err => {
		// console.error('axios request 请求出错：', err)
		return Promise.reject(err)
	}
)
axios.interceptors.response.use(
	response => {
		if (response.config && response.config.responseType === 'blob') {
			return Promise.resolve(response)
		}
		let data = response.data.data|| {}
		if (response && data) {
			if (data && (data['code'] === "201")) {
				//登录失效
			}
		}
		return Promise.resolve(data)
	},
	err => {
		// console.log(err.response.data.message)
		// console.error(err)
		// let res = {
		// 	success: false,
		// 	message: '系统错误，请重试！'
		// }
		return Promise.reject(err.response ? err.response.data.message : (err.message || '网络请求失败'))
	}
)
export default axios
